<template>
	<input
		v-model="valueData"
		v-bind="$attrs"
		@keyup.enter="onDataChanged"
		@blur="onDataChanged"
		@focusout="onDataChanged">
</template>

<script>
    export default {
        name: "FormattedInput",
		props:{
        	value: null,
			modelToValue: {type: Function, default: (model) => model},
			valueToModel: {type: Function, default: (value) => value},
		},

		watch: {
			value: {
				immediate: true,
				handler(newVal, oldVal) {
					this.valueData = this.modelToValueMethod(newVal)
				}
			}
		},

		data: () => ({
			valueData: null
		}),
		methods: {
			onDataChanged(){
				console.log("onDataChanged: this.valueData = ", this.valueData)
				if(this.valueData){
					let model = this.valueToModelMethod(this.valueData)
					this.$emit("input", model)
					this.$emit("change", model)
				}
			},
			modelToValueMethod(model){
				return this.modelToValue(model)
			},
			valueToModelMethod(value){
				return this.valueToModel(value)
			}
		},
		computed: {
			displayValue: {
				get() {
					return null
				},
				set(modifiedValue) {
					this.onDataChanged()
				}
			}
		}
    }
</script>

<style>

</style>
